import { __decorate } from "tslib";
import __NG_CLI_RESOURCE__0 from "./unsecure-capture-comment.component.html?ngResource";
import __NG_CLI_RESOURCE__1 from "./unsecure-capture-comment.component.scss?ngResource";
import { ChangeDetectionStrategy, ChangeDetectorRef, Component, } from "@angular/core";
import { ActivatedRoute, RouterModule } from "@angular/router";
import { RouterParamsService } from "../../shared/services/route-params.service";
import { SharedConstants } from "../../shared/constants/shared.constants";
import { AlertType } from "../../shared/models/alert";
import { FormControl, FormGroup, ReactiveFormsModule, Validators } from "@angular/forms";
import { UnsecureCommentService } from "./service/unsecure-comment.service";
import { AppConfig } from "../../app.config";
import { AppControllerService } from "../../app-controller.service";
import { CRUDOperation } from "../../shared/models/crud-operation-enum.model";
import { AppRoutingConstants } from "../../app-routing.constants";
import { DashboardRoutingConstants } from "../../core/dashboard/dashboard-routing.constants";
import { NavConstants } from "../../core/nav/nav.constants";
import { SaLongDatePipe } from "../../shared/pipes/sa-long-date/sa-long-date.pipe";
import { AttachmentFormData } from "./models/attachment-form-data-model";
import { UnsecureCaptureCommentConstants } from "./unsecure-capture-comment.constants";
import { Subject, take } from "rxjs";
import { takeUntil } from "rxjs/operators";
import { CommonModule, DatePipe } from "@angular/common";
import { MatSidenavModule } from "@angular/material/sidenav";
import { MatToolbarModule } from "@angular/material/toolbar";
import { SharedModule } from "../../shared/shared.module";
import { MatProgressSpinner } from "@angular/material/progress-spinner";
import { AutoUnsub } from "../../shared/decorators/autounsub.decorator";
import { phoneNumberValidator } from "../../shared/classes/phone-number-validator";
import { FileUtils } from "../../shared/utils/file-utils";
let UnsecureCaptureCommentComponent = class UnsecureCaptureCommentComponent {
    route;
    saLongDatePipe;
    appControllerService;
    unsecureCommentService;
    changeDetector;
    appController;
    datePipe;
    routerParamsService;
    appConfig;
    _destroy$ = new Subject();
    logoSrc = NavConstants.LOGO_SOURCE;
    appTitle = NavConstants.APP_TITLE;
    modulesLink = AppRoutingConstants.ROUTE_SEPERATOR + DashboardRoutingConstants.MODULES_ROUTE;
    homeLinkText = NavConstants.HOME_LINK_TEXT;
    componentType = UnsecureCaptureCommentConstants.COMPONENT_TYPE;
    businessUnitsEmptyMessage = UnsecureCaptureCommentConstants.BUSINESS_UNITS_EMPTY_MESSAGE;
    businessUnitLabel = UnsecureCaptureCommentConstants.BUSINESS_UNIT_LABEL;
    businessUnitFormControl = UnsecureCaptureCommentConstants.BUSINESS_UNIT_FORM_CONTROL;
    commentTextLabel = UnsecureCaptureCommentConstants.COMMENT_TEXT_LABEL;
    commentTextControl = UnsecureCaptureCommentConstants.COMMENT_TEXT_FORM_CONTROL;
    captureDateFormControl = UnsecureCaptureCommentConstants.CAPTURE_DATE_FORM_CONTROL;
    captureDateControlLabel = UnsecureCaptureCommentConstants.CAPTURE_DATE_LABEL;
    firstNameFormControl = UnsecureCaptureCommentConstants.FIRST_NAME_FORM_CONTROL;
    firstNameControlLabel = UnsecureCaptureCommentConstants.FIRST_NAME_TEXT_LABEL;
    lastNameFormControl = UnsecureCaptureCommentConstants.LAST_NAME_FORM_CONTROL;
    lastNameControlLabel = UnsecureCaptureCommentConstants.LAST_NAME_TEXT_LABEL;
    emailFormControl = UnsecureCaptureCommentConstants.EMAIL_FORM_CONTROL;
    emailControlLabel = UnsecureCaptureCommentConstants.EMAIL_TEXT_LABEL;
    contactNoFormControl = UnsecureCaptureCommentConstants.CONTACTNO_FORM_CONTROL;
    contactNoControlLabel = UnsecureCaptureCommentConstants.CONTACTNO_TEXT_LABEL;
    validationMessage = UnsecureCaptureCommentConstants.VALIDATION_MESSAGE_CONST;
    commentExpiredMessage = UnsecureCaptureCommentConstants.CAPTURE_NOT_ALLOWED;
    commentStatusClosed = UnsecureCaptureCommentConstants.COMMENT_STATUS_CLOSED;
    attachmentManagerFormControl = UnsecureCaptureCommentConstants.ATTACHMENT_MANAGER_FORM_CONTROL;
    titleLbl = UnsecureCaptureCommentConstants.TITLE;
    saveBtnLbl = SharedConstants.SAVE_LABEL;
    unauthorizedText = UnsecureCaptureCommentConstants.UNAUTHORIZED_TEXT;
    commentType = UnsecureCaptureCommentConstants.COMMENT_TYPE;
    requestId;
    businessUnits = [];
    addCommentForm;
    uploadData = new FormData();
    setSelectAttachmentRequired = false;
    allowedFiles;
    uploadedFiles = [];
    uploadedFilesForms = [];
    showBusyIndicator = true;
    enableSave = false;
    showContent = false;
    showUnauthorized = false;
    attachmentIds = [];
    currentLink;
    htmlEditorConfig = UnsecureCaptureCommentConstants.HTML_EDITOR_CONFIG;
    maximumLengthForTwentyWords = 20;
    maximumLengthForTwoHundredAndFifty = 250;
    dataSource;
    getResponsiblePersonsSubscription;
    getUSerEmailAddressesSubscription;
    paramsSubscription;
    moduleRolesEmails = [];
    toAddresses = [];
    responsiblePersonEmails = [];
    requestComment;
    uploadAttachmentSubscription;
    getAttachmentContentObservableSubscription;
    menuMode;
    displayOrgSettings;
    saveUnsecureCommentSubscription;
    getStepMetaObservableSubscription;
    moduleRoleToSendNotificationsTo;
    constructor(route, saLongDatePipe, appControllerService, unsecureCommentService, changeDetector, appController, datePipe, routerParamsService, appConfig) {
        this.route = route;
        this.saLongDatePipe = saLongDatePipe;
        this.appControllerService = appControllerService;
        this.unsecureCommentService = unsecureCommentService;
        this.changeDetector = changeDetector;
        this.appController = appController;
        this.datePipe = datePipe;
        this.routerParamsService = routerParamsService;
        this.appConfig = appConfig;
    }
    ngAfterViewInit() {
        this.loadConfig();
    }
    handleRouteChange() {
    }
    getTeamUsers() {
        // Gets Users assigned to the application
        const params = {
            jobId: this.requestComment.jobId,
            moduleId: this.requestComment.moduleId,
        };
        this.getResponsiblePersonsSubscription = this.unsecureCommentService.getResponsiblePersonsObservable(params).subscribe({
            next: (responsiblePersonResponse) => {
                if (responsiblePersonResponse && responsiblePersonResponse.length > 0) {
                    responsiblePersonResponse.forEach((responsiblePerson) => {
                        if (responsiblePerson.role?.role?.toLowerCase()?.trim() === this.moduleRoleToSendNotificationsTo?.toLowerCase()?.trim()) {
                            if (responsiblePerson.user) {
                                this.responsiblePersonEmails.push(responsiblePerson.user.email);
                            }
                        }
                    });
                }
                this.getStepMeta();
            },
            error: (err) => {
                this.appController.handleServerErrorMessage("responsiblePersonEmails", err, CRUDOperation.Get);
            }
        });
    }
    markFormControlsAsTouched() {
        Object.keys(this.addCommentForm.controls).forEach((controlName) => {
            this.addCommentForm.get(controlName).markAsTouched();
        });
        this.changeDetector.detectChanges();
    }
    ngOnInit() {
        this.initForm();
    }
    loadConfig() {
        this.appConfig.load().then(() => {
            const uploadFileSettings = AppConfig.settings.uploadFile;
            this.logoSrc = AppConfig.settings.municipalData.aflalogo;
            this.appTitle = AppConfig.settings.projectSettings.projectName;
            this.allowedFiles = uploadFileSettings.agsSupportedAttachmentFileTypes.split(",");
            this.paramsSubscription = this.routerParamsService.params.pipe(take(1)).subscribe(params => {
                this.requestId = params["requestId"];
                this.getRequestData();
            });
        });
    }
    initForm() {
        this.addCommentForm = new FormGroup({
            businessUnitFormControl: new FormControl(null, Validators.required),
            commentText: new FormControl(null, Validators.required),
            captureDateFormControl: new FormControl(this.saLongDatePipe.transform(new Date())),
            firstNameFormControl: new FormControl(null, Validators.required),
            lastNameFormControl: new FormControl(null, Validators.required),
            emailFormControl: new FormControl(null, [Validators.required, Validators.email]),
            contactNoFormControl: new FormControl(null, [Validators.required, phoneNumberValidator]),
        });
        this.addCommentForm.get(this.captureDateFormControl).disable();
    }
    getRequestData() {
        if (this.requestId == null || this.requestId === "undefined" || this.requestId === undefined) {
            this.enableSave = false;
            this.showBusyIndicator = false;
            this.showContent = false;
            this.showUnauthorized = true;
            this.changeDetector.detectChanges();
            return;
        }
        const params = {
            $expand: "Attachments",
            $filter: `requestGuid eq ${this.requestId}`
        };
        this.unsecureCommentService.getRequestCommentObservable(params).pipe(takeUntil(this._destroy$), take(1)).subscribe({
            next: (returnValue) => {
                this.requestComment = returnValue.value[0];
                if (this.requestComment) {
                    this.requestComment.links = [];
                    this.dataSource = this.requestComment.attachments;
                    if (this.requestComment.expireDate) {
                        const expireDate = new Date(this.requestComment.expireDate);
                        const now = new Date();
                        if (this.requestComment.status !== this.commentStatusClosed && expireDate > now) {
                            this.enableSave = true;
                            this.showContent = true;
                            this.showUnauthorized = false;
                            this.getBusinessUnits();
                        }
                        else {
                            this.showContent = false;
                            this.showUnauthorized = true;
                            this.showBusyIndicator = false;
                            this.changeDetector.detectChanges();
                        }
                    }
                    else {
                        this.enableSave = false;
                        this.showContent = false;
                        this.showUnauthorized = true;
                        this.showBusyIndicator = false;
                        this.changeDetector.detectChanges();
                        this.appControllerService.showMessage(this.commentExpiredMessage, AlertType.Warning);
                    }
                }
                else {
                    this.enableSave = false;
                    this.showContent = false;
                    this.showUnauthorized = true;
                    this.showBusyIndicator = false;
                    this.changeDetector.detectChanges();
                    this.appControllerService.showMessage(this.commentExpiredMessage, AlertType.Warning);
                }
            },
            error: (error => {
                this.appControllerService.handleServerErrorMessage(UnsecureCaptureCommentConstants.COMPONENT_TYPE, error, CRUDOperation.Get);
                this.showBusyIndicator = false;
                this.showContent = false;
                this.showUnauthorized = true;
            })
        });
    }
    getBusinessUnits() {
        const params = {
            $filter: `name eq 'BusinessUnit' and moduleId eq ${this.requestComment.moduleId}`,
        };
        this.unsecureCommentService.getUnsecureLookupsObservable(params).pipe(takeUntil(this._destroy$), take(1)).subscribe({
            next: (response) => this.onGetLookupsCompleted(response.value),
            error: (error) => {
                this.showBusyIndicator = false;
                this.appControllerService.handleServerErrorMessage(UnsecureCaptureCommentConstants.COMPONENT_TYPE, error, CRUDOperation.Get);
            }
        });
    }
    onGetLookupsCompleted(response) {
        response.forEach((item) => {
            if (item.name === UnsecureCaptureCommentConstants.COMMENT_LOOKUP_TYPE) {
                this.businessUnits.push((JSON.parse(item.content)).value);
            }
            if (this.businessUnits.length < 1) {
                this.appControllerService.showMessage(this.businessUnitsEmptyMessage, AlertType.Warning);
            }
        });
        this.showBusyIndicator = false;
        this.changeDetector.detectChanges();
        this.getTeamUsers();
    }
    saveAttachments() {
        this.showBusyIndicator = true;
        if (!this.addCommentForm.valid) {
            this.appControllerService.showMessage("Please complete all required fields", AlertType.Warning);
            this.showBusyIndicator = false;
            return;
        }
        this.markFormControlsAsTouched();
        if (this.addCommentForm.valid) {
            if (this.uploadedFilesForms.length > 0) {
                this.uploadedFilesForms.forEach((data, key) => {
                    const formData = new FormData();
                    formData.append(key.toString(), data.file);
                    formData.append("componentType", data.componentType);
                    formData.append("description", data.description);
                    formData.append("jobId", data.jobId.toString());
                    formData.append("moduleId", data.moduleId.toString());
                    formData.append("fileName", data.fileName);
                    formData.append("data", data.data);
                    formData.append("attachmentType", data.attachmentType);
                    formData.append("createdBy", data.createdBy);
                    this.uploadAttachmentSubscription = this.unsecureCommentService.uploadAttachment(formData, this.requestComment.jobId).subscribe({
                        next: (savedAttachment) => {
                            this.appControllerService.showMessage(SharedConstants.ADD_SUCCESS, AlertType.Success);
                            this.attachmentIds.push(savedAttachment.id);
                            if (this.attachmentIds.length === this.uploadedFilesForms.length) {
                                this.saveComment();
                            }
                        }, error: (err) => {
                            this.appControllerService.handleServerErrorMessage(UnsecureCaptureCommentConstants.COMPONENT_TYPE, err, CRUDOperation.Add);
                            this.showBusyIndicator = false;
                        }
                    });
                });
            }
            else {
                this.saveComment();
            }
        }
        else {
            this.appController.showMessage(SharedConstants.FORM_NOT_VALID, AlertType.Warning);
            this.showBusyIndicator = false;
        }
    }
    saveComment() {
        this.showBusyIndicator = true;
        if (!this.addCommentForm.valid) {
            this.appControllerService.showMessage("Please complete all required fields", AlertType.Warning);
            this.markFormControlsAsTouched();
            this.showBusyIndicator = false;
            return;
        }
        const comment = this.getCommentText();
        const businessUnit = this.getBusinessUnitText();
        const capturedBy = this.getCapturedByText();
        const email = this.getEmailText();
        const contactNo = this.getContactNoText();
        if (this.moduleRolesEmails.length > 0) {
            this.toAddresses = this.moduleRolesEmails;
        }
        else {
            this.toAddresses = this.responsiblePersonEmails;
        }
        this.markFormControlsAsTouched();
        const params = {
            jobId: +this.requestComment.jobId,
            moduleId: +this.requestComment.moduleId,
            requestGuid: this.requestComment.requestGuid,
            businessUnit,
            commentName: this.requestComment.commentName,
            comment,
            capturedBy,
            commentType: this.commentType,
            email,
            contactNo,
            attachments: this.attachmentIds,
            notifyEmailAddresses: this.toAddresses,
            stepName: this.requestComment.stepName
        };
        this.saveUnsecureCommentSubscription = this.unsecureCommentService.saveUnsecureComment(params).subscribe({
            next: () => {
                this.appControllerService.showMessage("Comment captured successfully", AlertType.Success);
                window.location.reload();
                this.showBusyIndicator = false;
            },
            error: (error => {
                this.appControllerService.handleServerErrorMessage(UnsecureCaptureCommentConstants.COMPONENT_TYPE, error, CRUDOperation.Get);
                this.showBusyIndicator = false;
            })
        });
    }
    getCommentText() {
        return this.addCommentForm.get(this.commentTextControl).value;
    }
    getEmailText() {
        return this.addCommentForm.get(this.emailFormControl).value;
    }
    getContactNoText() {
        return this.addCommentForm.get(this.contactNoFormControl).value;
    }
    getBusinessUnitText() {
        return this.addCommentForm.get(this.businessUnitFormControl).value;
    }
    getCapturedByText() {
        return `${this.addCommentForm.get(this.firstNameFormControl).value} ${this.addCommentForm.get(this.lastNameFormControl).value}`;
    }
    goBackToModules() {
        this.menuMode = "modules";
        this.displayOrgSettings = false;
    }
    uploadFile = (files) => {
        if (files.length === 0) {
            return;
        }
        const fileToUpload = files;
        let fileExist = false;
        this.uploadedFiles.forEach(function (file) {
            if (fileToUpload.name === file["name"] && fileExist === false) {
                fileExist = true;
            }
        });
        if (!fileExist) {
            this.uploadedFiles.push(fileToUpload);
            const reader = new FileReader();
            let fileString;
            reader.readAsDataURL(fileToUpload);
            reader.onloadend = (evt) => {
                if (evt.target.readyState === FileReader.DONE) {
                    const bytes = reader.result;
                    if (bytes.includes(",")) {
                        fileString = bytes.substring(bytes.indexOf(",") + 1);
                    }
                }
                const fileData = new AttachmentFormData();
                fileData.file = fileToUpload;
                fileData.componentType = this.componentType;
                fileData.description = this.componentType;
                fileData.jobId = this.requestComment.jobId;
                fileData.moduleId = this.requestComment.moduleId;
                fileData.fileName = fileToUpload.name;
                fileData.data = fileString;
                fileData.attachmentType = UnsecureCaptureCommentConstants.ATTACHMENT_TYPE;
                fileData.createdBy = this.getCapturedByText();
                this.uploadedFilesForms.push(fileData);
            };
        }
    };
    deleteAttachment(index) {
        const file = this.uploadedFiles[index];
        this.uploadedFiles.splice(index, 1);
        this.uploadedFilesForms.forEach((item, index) => {
            if (item.fileName === file.name) {
                this.uploadedFilesForms.splice(index, 1);
            }
        });
    }
    downloadFile(attachmentId, fileName) {
        this.getAttachmentContentObservableSubscription = this.unsecureCommentService.getAttachmentContentObservable(attachmentId)
            .subscribe({
            next: (response) => {
                FileUtils.openFile(fileName, response);
            },
            error: (error) => {
                this.appControllerService.handleServerErrorMessage(UnsecureCaptureCommentConstants.COMPONENT_TYPE, error, CRUDOperation.Get);
            }
        });
    }
    getEmailAddressesAndModuleRoles() {
        // Gets email addresses of system users that belong to a certain module role
        if (this.moduleRoleToSendNotificationsTo) {
            const params = {
                $expand: "users($select=email)",
                $filter: `moduleId eq ${this.requestComment.moduleId} and deleted eq false and toLower(role) eq toLower('${this.moduleRoleToSendNotificationsTo}')`
            };
            this.getUSerEmailAddressesSubscription = this.unsecureCommentService.getModuleRoleAndUsersObservable(params, +this.requestComment.moduleId).subscribe({
                next: (moduleRoleUsersResponse) => {
                    if (moduleRoleUsersResponse && moduleRoleUsersResponse.length > 0) {
                        moduleRoleUsersResponse.forEach((moduleRoleUsers) => {
                            if (moduleRoleUsers.users && moduleRoleUsers.users.length > 0) {
                                this.moduleRolesEmails = moduleRoleUsers.users.map((user) => user.email);
                            }
                        });
                    }
                },
                error: (err) => {
                    this.appController.handleServerErrorMessage("moduleRolesEmails", err, CRUDOperation.Get);
                }
            });
        }
    }
    getStepMeta() {
        const params = {
            $filter: `moduleId eq ${this.requestComment.moduleId} and deleted eq false and stepName eq '${this.requestComment.stepName}'`
        };
        this.getStepMetaObservableSubscription = this.unsecureCommentService.getStepMetaObservable(params, +this.requestComment.moduleId).subscribe({
            next: (stepMetaData) => {
                const stepMeta = JSON.parse(stepMetaData.value[0].metadata);
                if (stepMeta.moduleRoleToSendNotificationsTo && stepMeta.moduleRoleToSendNotificationsTo !== "") {
                    this.moduleRoleToSendNotificationsTo = this.moduleRoleToSendNotificationsTo = stepMeta.moduleRoleToSendNotificationsTo;
                    this.getEmailAddressesAndModuleRoles();
                }
            },
            error: (err) => {
                this.appController.handleServerErrorMessage("stepMeta", err, CRUDOperation.Get);
            }
        });
    }
    static ctorParameters = () => [
        { type: ActivatedRoute },
        { type: SaLongDatePipe },
        { type: AppControllerService },
        { type: UnsecureCommentService },
        { type: ChangeDetectorRef },
        { type: AppControllerService },
        { type: DatePipe },
        { type: RouterParamsService },
        { type: AppConfig }
    ];
};
UnsecureCaptureCommentComponent = __decorate([
    Component({
        standalone: true,
        selector: "app-unsecure-capture-comment",
        template: __NG_CLI_RESOURCE__0,
        imports: [
            MatSidenavModule,
            MatToolbarModule,
            SharedModule,
            ReactiveFormsModule,
            CommonModule,
            RouterModule,
            MatProgressSpinner
        ],
        changeDetection: ChangeDetectionStrategy.OnPush,
        styles: [__NG_CLI_RESOURCE__1]
    }),
    AutoUnsub()
], UnsecureCaptureCommentComponent);
export { UnsecureCaptureCommentComponent };
